import { Button, Form, SidebarModal } from '@domain-group/suit-theme'

import useAdAccountGroup, { useAdAccountGroupForm } from '@hooks/useAdAccountGroup'
import useProductLines from '@hooks/useProductLines'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'CreateAdAccountGroupModal'

type ModalCallbacks = {
  closeModal: () => void,
  createAdAccountGroup: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const CreateAdAccountGroupModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { createAdAccountGroup } = callbacks || {}

  const {
    callbacks: {
      createAdAccountGroup: createFn,
    },
    creating,
  } = useAdAccountGroup()

  const {
    entityState,
    entityState: {
      name,
      productLineId,
    },
    errors,
    handlers,
    saveEnabled,
  } = useAdAccountGroupForm({}, { validateOn: 'change' })

  const { productLines } = useProductLines({ performHttpRequests: true })

  const createAdAccountGroupPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Ad Account Group Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Ad Account Group" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Name" errorMessage={errors.name}>
            <input name="name" type="text" value={name} {...handlers} />
          </Form.Field>

          <Form.Field label="* Product Line" errorMessage={errors.productLineId} marginTop="large">
            <select data-value-type="number" name="productLineId" value={productLineId} {...handlers}>
              <option value="">Please Select...</option>
              {productLines.map(productLine => (
                <option key={productLine.id} value={productLine.id}>{productLine.displayName}</option>
              ))}
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          loadingBubbleColor="white"
          onClick={() => createAdAccountGroup(createAdAccountGroupPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Ad Account Group' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateAdAccountGroupModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
